import React, { Component } from 'react';
import { settingsFormTypes, statutoryDocTypes, urls, searchTableTypes } from '../constants';
import i18next from "../i18n";
import { InfoSettingsForm } from './forms/InfoSettingsForm';
import { PricesSettingsForm } from './forms/PricesSettingsForm';
import { ProfileSettingsForm } from './forms/ProfileSettingsForm';
import { StatutoryDocsForm } from './forms/StatutoryDocsForm';
import { YoucontrolSettingsForm } from './forms/YoucontrolSettingsForm';
import { ListOfAlfresco } from './listsOfAlfresco/ListOfAlfresco';
import { ListTabs } from './listsOfAlfresco/ListTabs';
import * as ListOfCompanies from './listsOfAlfresco/ListOfCompanies';
import * as ListOfUsers from './listsOfAlfresco/ListOfUsers';
export class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuItems: []
        };
    }
    componentDidMount() {
        fetch(`menu/GetLeftMenu?type=${this.props.controller}`)
            .then(async (response) => {
                if (response.ok) {
                    let data = await response.json();
                    this.setState({ menuItems: data.menu.menuItems });
                }
                else if (response.status === 403) History.push(urls.accessDeniedUrl);
                if (!response.ok) require("./ModalDialogsTemplates").unknownErrorMessageDialog();
            });
    }
    renderContent(menuItem) {
        // eslint-disable-next-line default-case
        switch (menuItem?.name) {
            case 'profile': return (<ProfileSettingsForm />);
            case 'myCompany': return (<ListOfAlfresco saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Companies}`} key={0} parentComponent={ListOfCompanies} hideFilter={true} />);
            case 'companies': return (<ListOfAlfresco saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Companies}`} key={1} parentComponent={ListOfCompanies} />);
            case 'users': return (<ListOfAlfresco saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Users}`} key={2} parentComponent={ListOfUsers} type={this.props.controller} />);
            case 'statutoryDocs':
                return (<StatutoryDocsForm key={statutoryDocTypes.statutory} docType={statutoryDocTypes.statutory} baseUrl={menuItem.link?.url} canEdit={true} />);
            case 'templates':
                return (<StatutoryDocsForm key={statutoryDocTypes.template} docType={statutoryDocTypes.template} baseUrl={menuItem.link?.url} canEdit={true} />);
            case 'prices': return (<PricesSettingsForm />);
            case 'info': return (<InfoSettingsForm />);
            case 'integrations': return (<YoucontrolSettingsForm />);
        }
    }
    render() {
        const { menuItems } = this.state;
        let selected = menuItems.find(item => item.link && window.location.pathname.includes(item.link.url));
        if (!selected && menuItems.length > 0) selected = menuItems[0];
        const filteredItems = menuItems?.filter((item) => !item.hiddenForTabs);

        return (<div className="content settPage">
            <h1>{this.props.controller === settingsFormTypes.settingsType ? i18next.t("settings") : i18next.t("administration")}</h1>
            {filteredItems && <ListTabs items={filteredItems} selectedItem={selected} />}
            <div className="settings-block">{this.renderContent(selected)}</div>
        </div>);
    }
}